// Friendly wizard copy for the launch-scale server limits (2026-07-04), factored
// out of App.tsx so the mapping is unit-testable. These are the two currently-
// generic refusals a real public-launch day can actually hit: the daily
// conversion-bucket cost cap (429 from /runs/start) and an oversized upload
// (413 from /prescan, /runs/preview, or /runs/start) — both previously surfaced
// as whatever raw `detail` string the server happened to send.
//
// Returns undefined when the error isn't one of these — callers fall back to
// their existing generic handling (e.message) unchanged.

export function friendlyLaunchLimitMessage(err: {
  status?: number;
  code?: string;
}): string | undefined {
  if (err.code === "daily_conversion_cap_hit") {
    // The daily conversion-bucket cap (cost_cap.py) is a launch-day safety
    // net, not a per-user problem — the code + payment are untouched (the
    // cap fires BEFORE the code is burned or the chain spawns; see
    // runs.py's "Daily cost-cap (conversion bucket)" gate). Resets at
    // midnight UTC, so "tomorrow" is accurate regardless of the caller's
    // timezone.
    return (
      "Aurora is at capacity today — nothing was used: your code and " +
      "payment are safe. Please come back tomorrow."
    );
  }
  if (err.status === 413) {
    // upload_limits.read_capped raises a bare HTTPException (no `code`
    // field) — status alone is the only signal across all three upload
    // endpoints (/prescan, /runs/preview, /runs/start).
    return (
      "This file is larger than Aurora can accept (about 128 MB). If your " +
      "export is really this big, reply to your access email and we'll " +
      "handle it directly."
    );
  }
  return undefined;
}
